import { render } from "./ReportHeaderComponent.vue?vue&type=template&id=5c89f2f7"
import script from "./ReportHeaderComponent.vue?vue&type=script&lang=js"
export * from "./ReportHeaderComponent.vue?vue&type=script&lang=js"

import "./ReportHeaderComponent.vue?vue&type=style&index=0&id=5c89f2f7&lang=scss"
script.render = render

export default script